import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".818",
  d: "M23.089 26.178a4.413 4.413 0 1 0 0-8.826 4.413 4.413 0 0 0 0 8.826"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".818",
  d: "M31.915 21.765a8.825 8.825 0 1 0-8.826 8.826 8.79 8.79 0 0 0 8.826-8.826"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".818",
  d: "M23.902 17.427a4.41 4.41 0 0 1-5.145 5.146M15.159 17.89v-.004M16.849 28.004l-3.274-3.274"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".818",
  d: "M14.263 21.764c0 2.943-1.544 4.192-2.647 5.297l-3.53-3.531c1.103-1.103 2.647-2.352 2.647-5.295A8.824 8.824 0 0 1 25.8 11.998l3.53 3.53"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }